import React from "react";
import PropTypes from "prop-types";
import Button from "../Button";
import Input from "../Input";
import { post } from "../../lib/Fetching";

export default class GroupRenamer extends React.Component {
  state = {
    name: this.props.quotable.name
  };

  handleNameChange = event => {
    this.setState({
      name: event.target.value
    });
  };

  renameGroup = event => {
    const {
      onUpdated,
      attempt_id,
      quotable: { quote_group_id }
    } = this.props;
    const { name } = this.state;

    post("/quote_groups/rename.json", {
      attempt_id,
      quote_group_id,
      name
    }).then(onUpdated);
  };

  render() {
    const { quotable, onCancel } = this.props;
    const { name } = this.state;
    return (
      <div className="panel panel-default">
        <div className="panel-body">
          <div className="form-inline" style={{ textAlign: "center" }}>
            <div className="form-group">
              <Input
                onPressEnter={this.renameGroup}
                onPressEscape={onCancel}
                autoFocus
                className="form-control"
                placeholder="Add new group name..."
                value={name}
                style={{ width: 250 }}
                onChange={this.handleNameChange}
              />
            </div>
            <div className="form-group" style={{ marginLeft: 20 }}>
              <Button
                title="Rename Group"
                disabled={!name}
                onClick={this.renameGroup}
                primary
              />
            </div>
            <div className="form-group" style={{ marginLeft: 20 }}>
              <Button title="Cancel" onClick={onCancel} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
